<template>
  <v-data-table :headers="headers" :items="data" class="elevation-0">
    <template v-slot:[`item.text`]="{ item }">
      <v-alert text prominent :type="item.type"   class="ma-0">
        {{ $i18n.locale == "ar" ? item.ar_text : item.en_text }}
      </v-alert>
    </template>

    <template v-slot:[`item.created_at`]="{ item }">
      {{ $subStringDate(item.created_at) }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "TableInstruction",
  props: ["data"],

  data() {
    return {
      headers: [
        // {
        //   text: "#ID",
        //   align: "center",
        //   sortable: true,
        //   value: "id",
        // },
        { text: this.$t("instructions.table.text"), value: "text" },
        { text: this.$t("instructions.table.created_at"), value: "created_at" },
      ],
    };
  },

  created() {
    this.param = this.$router.history.current.params.id;
  },
};
</script>
